/**
 * Commands service – ambil commands untuk control device.
 */

import { getWebosCommands } from '../repository.js';

export async function fetchCommands(token, options = {}) {
  const { ok, status, json } = await getWebosCommands(token, options);
  if (ok) return json?.data || [];
  const errCode = json?.error || `HTTP_${status || 0}`;
  const message = json?.message || 'Commands request failed';
  const e = new Error(message);
  e.code = errCode;
  e.status = status;
  e.payload = json;
  throw e;
}
